import React from 'react'
import { useSelector } from 'react-redux'
import { ListGroup } from 'react-bootstrap'
import * as s from '../Eliminator/PickReport.scss'
import NflTeamListItem from '../Football/NflTeamListItem'
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

const PickReport = () => {
    const { seasonId, seasonMode, week, playoffWeek, standings } = useSelector(state => state.terminator)
    const table = standings?.[seasonId]
    const currentWeek = seasonMode === 'Postseason' ? playoffWeek : week
    const afterDeadline = table?.weeks?.some(w => w.seasonMode === seasonMode && w.week === currentWeek && w.isAfterDeadline)
    const pickReport = table?.pickReport || []

    if (!['Regular', 'Postseason'].includes(seasonMode) || !afterDeadline) return null
    return (
        <div className={s.container}>       
            <div className={s.header}>
                <div className={s.eyebrow}>History</div>
                <h4>Picks This Season</h4>
            </div>
            <ListGroup className={s.pickReportList}>
            {pickReport && pickReport.map((r, index) =>
            <NflTeamListItem key={`eliminator-pick-report-${r.teamId}`} {...r}
                right={<div className={s.graphContainer}>
                    {[{ type: 'For', label: `${r.pickedRecord}`, value: `${r.pickedPct * 100.0}` },{ type: 'Against', label: `${r.againstRecord}`, value: `${r.againstPct * 100.0}` }].map(_bar =>
                    <div className={s.graph + (_bar.value ? ` ${s[_bar.type.toLowerCase()]}` : '')} key={`eliminator-pick-report-${r.teamId}-${_bar.type}`}>
                        <CircularProgressbarWithChildren value={_bar.value} text={_bar.label}>
                            <div className='CircularProgressbar-text'>
                                <div>{_bar.type}:</div>
                                <div>{_bar.label}</div>
                            </div>
                        </CircularProgressbarWithChildren>
                    </div>
                    )}
                </div>} />
            )}
            </ListGroup>
        </div>
    )
}

export default PickReport
